/**
 * Utility functions for formatting data in the application
 */

/**
 * Format date to Vietnamese locale string
 * @param dateValue Date value to format (string, Date, or null/undefined)
 * @returns Formatted date string or 'Không có' if no valid date
 */
export function formatDate(dateValue: string | Date | null | undefined): string {
	if (!dateValue) return 'Không có';

	try {
		const date = new Date(dateValue);
		if (isNaN(date.getTime())) return 'Không có';

		return date.toLocaleDateString('vi-VN', {
			year: 'numeric',
			month: '2-digit',
			day: '2-digit'
		});
	} catch {
		return 'Không có';
	}
}

/**
 * Format score to display with proper decimal places
 * @param score Score value to format (number or null/undefined)
 * @returns Formatted score string or 'Không có' if no valid score
 */
export function formatScore(score: number | null | undefined): string {
	if (score === null || score === undefined || isNaN(score)) {
		return 'Không có';
	}

	return score.toFixed(2);
}

export function hideLongText(text: string, maxLength: number): string {
	if (text.length <= maxLength) return text;
	return text.slice(0, maxLength) + '...';
}